import { apiService } from '../../api/apiService';

export const getCountries =
  () =>
    async (
    ) => {
      const response = await apiService.systemV10CountriesList();
      return response;
    };